import { ICON_ARROW_DOWN } from '../../shared/lib/icons.ts';

export default function loadShowMore($showMores: NodeListOf<HTMLDivElement>) {
	$showMores.forEach(($container) => {
		const maxHeight = parseFloat(getComputedStyle($container).getPropertyValue('max-height'));

		if ($container.clientHeight < maxHeight) {
			$container.classList.remove('show-more');

			return;
		}

		const initialScrollHeight = $container.scrollHeight;
		const buttonHeight = getComputedStyle($container).getPropertyValue('--_btn-size');

		const $iconButtonAdd = document.createElement('template');
		$iconButtonAdd.innerHTML = ICON_ARROW_DOWN;

		const $button = document.createElement('button');
		$button.classList.add('btn-close');
		$button.appendChild($iconButtonAdd.content.firstChild as ChildNode);
		$button.addEventListener('click', () => {
			if ($container.classList.contains('show-more--expanded')) {
				$container.classList.remove('show-more--expanded');
				$container.style.removeProperty('--_max-height');
			} else {
				$container.classList.add('show-more--expanded');

				const padding = getComputedStyle($container).getPropertyValue('--_padding-bottom');

				$container.style.setProperty('--_max-height', `calc(${initialScrollHeight}px + ${buttonHeight} + ${padding})`);
			}
		});

		$container.appendChild($button);
	});
}
